import { render, staticRenderFns } from "./OldLogin.vue?vue&type=template&id=1a0984c6&"
import script from "./OldLogin.vue?vue&type=script&lang=js&"
export * from "./OldLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports